import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/(layout)/(event)/_modules/desc/index.js");
;
import(/* webpackMode: "eager" */ "/app/components/AspectRatioCover.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Folding.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/page/common/card/live/countdown/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeLiveContextProvider"] */ "/app/components/page/common/card/live/list/subscribe.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/page/common/card/live/statusButton/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/page/common/live/player/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/user-tracking/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/user-tracking/page-views/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/wechatShare/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/public/imgs/live.svg");
;
import(/* webpackMode: "eager" */ "/app/public/imgs/translate.svg");
